import React from 'react';
import NotFound from '../components/NotFound';

const NotFoundPage: React.FC = () => {
  return <NotFound type="page" />;
};

export default NotFoundPage;